<template>
<div>
<multipane v-if="!isPhoneView" class="vertical-panes" layout="vertical">

 <div class="pane" :style="{ width: '50%' }">

  <v-select name="serviceid" :items="services" :disabled="DisableCheckComponents" item-text="displayname" @change="getChosenServiceDetails()" item-value="id" label="Choose Service" light v-model="chosenserviceid"></v-select>
Service Name: {{chosenservice.name}}
<br>
Service Description: <p v-html="chosenservice.description"></p>
<br>
<br>
<v-textarea v-if="showIMEIBox" :disabled="DisableCheckComponents" label="IMEIs" v-model="imeilist"></v-textarea>
<br>
<toggle-button :value="false" :disabled="DisableCheckComponents" v-if="showOrderButton" color="#82C7EB" :width=65 :sync="true" v-model="instantcheck" :labels="{checked: 'Instant', unchecked: 'Order'}" />
<v-btn v-if="showOrderButton" :disabled="DisableCheckComponents" @click.native="onSubmit" color="info">Submit</v-btn>
</div>

<multipane-resizer></multipane-resizer>

 <div class="pane" :style="{ flexGrow: 1 }">

 <v-btn style="float:right" v-if="!instantcheck" @click.native="clearLog" color="red">Clear Log</v-btn>

 <br>
 Progress: {{qtydone}}/{{totalsubmitted}}
 <div class="msg-container" v-overflow-scroll="true" scroll-to="last-child">
  <div v-for="(item, index) in msgList" class="msg">{{ item }}</div>
   </div>
  </div>

</multipane>

<multipane v-else class="horizontal-panes" layout="horizontal">

 <div class="pane" :style="{ width: '90%' }">

  <v-select name="serviceid" :items="services" item-text="displayname" @change="getChosenServiceDetails()" item-value="id" label="Choose Service" light v-model="chosenserviceid"></v-select>
Service Name: {{chosenservice.name}}
<br>
Service Description: <p v-html="chosenservice.description"></p>
<br>
<br>
<v-textarea v-if="showIMEIBox" :disabled="DisableCheckComponents" label="IMEIs" v-model="imeilist"></v-textarea>
<br>
<toggle-button :value="false" v-if="showOrderButton" color="#82C7EB" width=65 :sync="true" v-model="instantcheck" :labels="{checked: 'Instant', unchecked: 'Order'}" />
<v-btn v-if="showOrderButton" :disabled="DisableCheckComponents" @click.native="onSubmit" color="info">Submit Order</v-btn>
</div>

<multipane-resizer></multipane-resizer>

 <div class="pane" :style="{ flexGrow: 1 }">
 <v-btn style="float:right" v-if="!instantcheck" @click.native="clearLog" color="red">Clear Log</v-btn>

 <br>
 Progress: {{qtydone}}/{{totalsubmitted}}
 <div class="msg-container" v-overflow-scroll="true" scroll-to="last-child">
  <div v-for="(item, index) in msgList" class="msg">{{ item }}</div>
   </div>
  </div>

</multipane>



    <confirm-dialog :dialog="showDialog" :dialogTitle="dialogTitle" :dialogText="dialogText" @onConfirm="onConfirm" @onCancel="onCancel" ></confirm-dialog>
    <v-snackbar v-if="loading===false" :right="true" :timeout="timeout" :color="mode" v-model="snackbar" >
      {{ notice }}
      <v-btn dark flat @click.native="closeSnackbar">Close</v-btn>
    </v-snackbar>


       </div>

</template>
<script>
/* global Store */
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { mapState, dispatch } from 'vuex'
import api from "@/utils/backend-api";
import Multipane from '@/components/multipane.vue';
import MultipaneResizer from '@/components/multipane-resizer.vue';
import Vue from 'vue'
import VueOverflowScroll from 'vue-overflow-scroll'
import Router from 'vue-router'
import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton)
Vue.use(Router)
Vue.use(VueOverflowScroll)

  export default {
    watch: {
      instantcheck: function () {
        if (this.instantcheck)
        {
          document.title = this.chosenservice.name
          this.msgList = [];
        }
        else {
        document.title = window.location.hostname
        if (localStorage.getItem("listshistory") === null){
          this.msgList = [];
        }
        else {
          this.msgList = JSON.parse(localStorage.getItem("listshistory"));
        }
        }
      },
      chosenservice: function () {
        if (this.instantcheck)
        {
          document.title = this.chosenservice.name
        }
        else {
        document.title = window.location.hostname
        }
      },
      qtydone: function () {
        if (this.qtydone === this.totalsubmitted){
        this.DisableCheckComponents = false;
        }
        else {
        this.DisableCheckComponents = true;
        }
      }
    },
    components: {
      ConfirmDialog,
      Multipane,
      MultipaneResizer
    },
    data () {
      return {
        categoryId: null,
        showDialog: false,
        dialogTitle: "",
        dialogText: "",
        orderDateMenu: false,
        shippedDateMenu: false,
        errors: [],
        title: '',
        snackbarStatus: false,
        timeout: 3000,
        color: '',
        services: [],
        chosenserviceid: "",
        chosenservice: [],
        msgList: [],
        imeilist: "",
        showIMEIBox: false,
        showOrderButton: false,
        showCheckButton: false,
        DisableCheckComponents: false,
        isPhoneView: false,
        pendingOrders: [],
        qtydone: 0,
        totalsubmitted: 0,
        nonce: 0,
        creditsUpdated: false,
        instantcheck: false
      }
    },
    computed: {
      ...mapState('orders',
        {
          order: 'order',
          lastcreatedorder: 'lastcreatedorder',
          categories: 'categories',
          products: 'products',
          loading: 'loading',
          mode: 'mode',
          snackbar: 'snackbar',
          notice: 'notice'
        }),
    },
    methods: {
    leaving: function () {
               alert("Leaving...");
    },
    clearLog: function(){
      this.msgList = [];
      localStorage.setItem("listshistory", JSON.stringify(this.msgList));
    },
    updateCredits: function(){
      api.getData("userinfo.php").then(res => {
         if (res.data){
           const user = res.data.user;
           const token = localStorage.token;
           Store.dispatch('user/updateUser', {user, token});
         }
         });
    },
    ordersFetcher: function(vue){
      var x = setInterval(function(){
        if (vue.qtydone !== vue.totalsubmitted)
        {
          api.postData("fetchOrders.php?format=web&nonce=" + vue.nonce, {"orderslist": vue.pendingOrders.toString()}).then(
            res => {
            var repliesArray = res.data;
            var arrayLength = Object.keys(repliesArray).length;
            for (var i = 1; i < arrayLength; i++) {
            var r = repliesArray[i]["reply"].replace(new RegExp("<br>", "g"), '\n')
            if (r.length > 1){
            vue.qtydone++;
            vue.$set(vue.msgList, repliesArray[i]["id"], r);
            for (var x = vue.pendingOrders.length + 1; x >= 0; x--) {
                if (vue.pendingOrders[x] === (parseInt(repliesArray[i]["id"]) + vue.nonce) + "") {
                // console.log("match");
                   vue.pendingOrders.splice(x, 1);
                }
            }
            }

          }

            },
            err => {
            alert("Error Fetching Orders");
            if (err.message.includes("403"))
              {
                this.$router.push('/login')
              }
            }
          );
        }
        else {

          if (vue.creditsUpdated === false){
              vue.updateCredits();
              vue.creditsUpdated = true;
          }
        }
      }, 10000);
    },
    countIMEIs () {
      return this.imeilist.length ? this.imeilist.split(/\r\n|\r|\n/).length : 0;
    },
    checkIMEI (imei, link){
    let x = link.replace("[imei]", imei);
    api.getDataByURL(x).then(
      res => {
        this.msgList.unshift(res.data)
      },
      err => {
        console.log(err);
      }
    );
    },
    getServices () {
    let link = "getServices.php";
    if (window.location.hostname.includes("7")){
      link = link + "?lang=cn";
    }
      api.getData(link).then(
        res => {
           this.services = res.data;
        },
        err => {
        if (err.message.includes("403"))
          {
            this.$router.push('/login')
          }

        }
      );
    },
    onSubmit () {
     this.dialogTitle = this.chosenservice.displayname
     this.dialogText = "Do you wish to submit " + this.countIMEIs() + " IMEI(s)?"
     this.showDialog = true;
    },
    onCheck () {
     this.DisableCheckComponents = true;
     let link = this.chosenservice.directlink;
      var imeisArray = this.imeilist.split("\n");
       for (var i = 0; i < imeisArray.length; i++){
          this.checkIMEI(imeisArray[i], link)
       }
       this.DisableCheckComponents = false;
       this.imeilist = "";
    },
    onCancel () {
     this.showDialog = false;
    },
    getChosenServiceDetails (){
          for (var i = 0; i < this.services.length; i++){
            if (this.services[i].id === this.chosenserviceid){
              this.chosenservice = this.services[i]
              this.showIMEIBox = true
              if (this.services[i].directlink.length !== 0)
              {
                this.showCheckButton = true
              }
              else
              {
                this.showCheckButton = false
              }
              if (this.services[i].ordersupport === "1")
              {
                this.showOrderButton = true
              }
              else
              {
                this.showOrderButton = false
              }
              return
            }
          }
          this.showIMEIBox = false
          return
    },
      selectCustomer (item) {
        this.order.customerId = item.value
      },
      getOrderById () {
        Store.dispatch('orders/getOrderById', this.$route.params.id)
      },
      cancel () {
        this.$router.push({ name: 'WorkJobs' })
      },
      remove (item) {
        this.selectedProduct = item;
        this.dialog = true;
      },
      onConfirm () {
        let count = this.countIMEIs();
        this.showDialog = false;
        if (this.countIMEIs() === 0) {
          alert("Empty list");
          return;
        }
        this.DisableCheckComponents = true;

        let orderData = {
          comments: this.listName,
          imeilist: this.imeilist,
          serviceid: this.chosenserviceid
        }
        this.nonce = 0;
        this.qtydone = 0;
        this.totalsubmitted = 0;
        if (this.instantcheck) {
        this.msgList = [];
        }
        this.creditsUpdated = false;
        let x = "";
        if (!this.instantcheck)
        {
          x = "?type=list"
        }
        api.postData("submitOrder.php" + x, orderData).then(
          res => {
          if (res.data.includes("OK")){
          res.data = res.data.replace("OK ", "");

          if (this.instantcheck){
          this.pendingOrders = res.data.split(",");
          this.totalsubmitted = this.pendingOrders.length;
          this.nonce = this.pendingOrders[0] - 1;
          if (this.nonce === -1){
          alert("Order Error");
          this.totalsubmitted = 0;
          }
          }
          else {
          if (localStorage.getItem("listshistory") !== null){
            this.msgList = JSON.parse(localStorage.getItem("listshistory"));
            this.msgList.push(count + " IMEIs submitted on " + this.chosenservice.name + " with list #" + res.data);
            localStorage.setItem("listshistory", JSON.stringify(this.msgList));
          }

          }

          Store.commit("orders/setNotice", { notice: "Order successfully submitted!" });
          }
          else {
            alert("Error submitting order:" + res.data);
          }
          },
          err => {
          alert("Error Submitting Order");
          if (err.message.includes("403"))
            {
              this.$router.push('/login')
            }
          }
        );
        this.imeilist = "";
        if (!this.instantcheck){
          this.DisableCheckComponents = false;
        }
      },
      saveProduct () {
        Store.dispatch('orders/addProductToOrder', this.productId)
        this.productId = null;
        this.addProductModal = false
      },
      cancelAddProduct () {
        this.addProductModal = false
      },
      getCategories () {
        Store.dispatch('orders/getCategories')
      },
      getProductsByCategory (){
        this.categoryId && Store.dispatch('orders/getProductsByCategory', this.categoryId)
      },
      closeSnackbar () {
        Store.commit("orders/setNotice", { notice: "" });
      },
    },
    created () {
      if (screen.width <= 600) {
       this.isPhoneView = true;
     }

     if (localStorage.getItem("listshistory") === null){
       this.msgList = [];
     }
     else {
       this.msgList = JSON.parse(localStorage.getItem("listshistory"));
     }
      this.getServices();

    },
    mounted () {

      this.ordersFetcher(this);
    },
    ready() {
        window.addEventListener('beforeunload', this.leaving);
        window.addEventListener('onblur', this.leaving);
    }
  }
</script>
<style>
.vertical-panes {
  width: 100%;
  height: 400px;
  border: 1px solid #ccc;
}
.vertical-panes > .pane {
  text-align: left;
  padding: 15px;
  overflow: hidden;
  background: #eee;
}
.vertical-panes > .pane ~ .pane {
  border-left: 1px solid #ccc;
}
.msg-container{
  display:flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  border:1px solid rgba(0,0,0,.5);
}
.msg{
  white-space: pre;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// PlaceOrder.vue?38acc56e